import {
  groupBy,
  map,
  sortBy,
  uniqBy,
} from 'lodash';
import CustomError from '@/utils/custom-error';
import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const gatherShareClassesFundBySecID = (data) => {
  const groupedData = groupBy(sortBy(data, 'secId'), 'secId');
  return map(groupedData, (groupedFunds) => {
    const fundData = {
      ...groupedFunds[0],
      statusArray: uniqBy(groupedFunds.map((fund) => fund.pendingStatus || fund.status), 'name'),
      fiduciaryFundIDs: groupedFunds.map((fund) => fund.fiduciaryFundID),
      fiduciaryClient: groupedFunds.map((fund) => ({
        ...fund.fiduciaryClient,
        fund: {
          ...fund,
        },
      })),
    };
    return fundData;
  });
};

export const getShareClassesByClientAndFundId = ({
  selectedClient,
  fundID,
}) => {
  const url = `/fiduciaryclients/${selectedClient}/shareclasses/${fundID}`;
  return request.get(url);
};

export const getShareClassesByFiduciaryAndFundId = async ({
  fiduciary,
  fundID,
}) => {
  const url = `/fiduciaries/${fiduciary}/shareclasses/${fundID}`;
  try {
    const response = await request.get(url);
    return {
      ...response,
      rawData: response.data,
      data: gatherShareClassesFundBySecID(response.data),
    };
  } catch (err) {
    throw new CustomError(err, err.message);
  }
};
